import {Component, Input} from '@angular/core';
import {
    DsBoxModule,
    DsColumnData,
    DsLoadingAreaConfiguration,
    DsLoadingAreaService,
    DsModalModule,
    DsRowData,
    DsTableConfig,
    DsTabsModule,
} from '@bmw-ds/components';
import {TableComponent} from 'src/app/components/table/table.component';
import {CommonModule} from '@angular/common';
import {RequestPayload} from 'src/app/models/stock-search-payload.model';
import {StockItem} from 'src/app/models/stock-item.model';
import {StockService} from '../../services/stock.service';
import {StockResponse} from '../../models/stock-response.model';
import {DemoStockResponse} from '../../models/demo-stock-response.model';
import {DemoStockRequest} from '../../models/demo-stock-request.model';
import {CosyUrlResponse} from '../../models/cosy-response.model';
import {CreateGoodsMvtRequest} from '../../models/create-goods-request.model';
import {GoodsMovementService} from '../../services/goods.service';
import {ShowroomDocRequest, ShowroomDocResponse,} from '../../models/showroom-document.model';
import {forkJoin, of} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Component({
    selector: 'app-tabs',
    standalone: true,
    imports: [
        DsTabsModule,
        CommonModule,
        TableComponent,
        DsBoxModule,
        DsModalModule,

    ],
    templateUrl: './tabs.component.html',
    styleUrl: './tabs.component.scss',
})
export class TabsComponent {
    @Input() requestPayload!: RequestPayload;
    @Input() isModelSelected: boolean = false;
    modalData = {
        title: '',
        message: '',
    };
    stockItems: StockItem[] = [];
    rowsData: DsRowData[] = [];
    columnData: DsColumnData[] = [
        // {field: 'image', headerName: 'Image'},
        {field: 'VIN', headerName: 'VIN'},
        {field: 'model', headerName: 'Model Code'},
        {field: 'description', headerName: 'Description'},
        {field: 'storageLocationAvailable', headerName: 'Storage Locator'},
        {field: 'visibleOnDSP', headerName: 'Visible on DSP'},
        {field: 'rfsDate', headerName: 'RFS Date'},
        {field: 'age', headerName: 'Age'},
        {field: 'tracking', headerName: 'Tracking'},
        {field: 'templateID', headerName: 'Template ID'},
        {field: 'download', headerName: ''},
    ];

    otpColumnData: DsColumnData[] = [
        // {field: 'image', headerName: 'Image'},
        {field: 'VIN', headerName: 'Vin'},
        {field: 'model', headerName: 'Model Code'},
        {field: 'description', headerName: 'Description'},
        {field: 'storageLocationAvail', headerName: 'Storage Location'},
        {field: 'rfsDate', headerName: 'RFS Date'},
        {field: 'age', headerName: 'Age'},
        {field: 'customer', headerName: 'Customer'},
        {field: 'dspReference', headerName: 'DSP Reference'},
        {field: 'daysToExpiry', headerName: 'Days to expiry'},
        {field: 'otpStatus', headerName: 'OTP Status'},
        {field: 'daysAtStatus', headerName: 'Days at Status'},
        {field: 'otpAction', headerName: ''},
    ];

    quotationColumnData: DsColumnData[] = [
        // {field: 'image', headerName: 'Image'},
        {field: 'VIN', headerName: 'VIN'},
        {field: 'model', headerName: 'Model Code'},
        {field: 'description', headerName: 'Description'},
        {field: 'storageLocationAvail', headerName: 'Storage Location'},
        {field: 'rfsDate', headerName: 'RFS Date'},
        {field: 'age', headerName: 'Age'},
        {field: 'customer', headerName: 'Customer'},
        {field: 'dspReference', headerName: 'DSP Reference'},
        {field: 'daysToExpiry', headerName: 'Days to Expiry'},
        {field: 'otpStatus', headerName: 'OTP Status'},
        {field: 'daysAtStatus', headerName: 'Days at Status'},
        {field: 'quotationAction', headerName: ''},
    ];

    demoStockColumnData: DsColumnData[] = [
        // {field: 'image', headerName: 'Image'},
        {field: 'VIN', headerName: 'VIN'},
        {field: 'model', headerName: 'Model Code'},
        {field: 'modelDescription', headerName: 'Description'},
        {field: 'purpose', headerName: 'Purpose'},
        {field: 'mileage', headerName: 'Mileage'},
        {field: 'retailPrice', headerName: 'Retail Price'},
        {field: 'dateCreated', headerName: 'Date Created'},
        {field: 'proofOfDeliveryDate', headerName: 'Proof Of Delivery Date'},
        {field: 'lastAction', headerName: 'Last Action'},
        {field: 'daysToDefleet', headerName: 'Days To De-fleet'},
        {field: 'demoStockAction', headerName: ''},
    ];

    reservedStockColumnData: DsColumnData[] = [
        // {field: 'image', headerName: 'Image'},
        {field: 'VIN', headerName: 'Vin'},
        {field: 'model', headerName: 'Model Code'},
        {field: 'description', headerName: 'Description'},
        {field: 'receivingPlant', headerName: 'Receiving Plant'},
        {field: 'storageLocationAvail', headerName: 'Storage Location'},
        {field: 'rfsDate', headerName: 'RFS Date'},
        {field: 'age', headerName: 'Age'},
        {field: 'tracking', headerName: 'Tracking'},
        {field: 'templateID', headerName: 'Template ID'},
        {field: 'otpStatus', headerName: 'OTP Status'},
        {field: 'otpStatusDate', headerName: 'OTP Status Date'},
        {field: 'daysAtStatus', headerName: 'Days at Status'},
        {field: 'statusCode', headerName: 'Status Code'},
        {field: 'reservedDownload', headerName: ''},
    ];

    nscColumnData: DsColumnData[] = [
        // {field: 'image', headerName: 'Image'},
        {field: 'VIN', headerName: 'VIN'},
        {field: 'model', headerName: 'Model Code'},
        {field: 'description', headerName: 'Description'},
        {field: 'storageLocationAvail', headerName: 'Storage Location'},
        {field: 'rfiWeek', headerName: 'RFI Week'},
        {field: 'rfsDate', headerName: 'RFS Date'},
        {field: 'productionWeek', headerName: 'Production Week'},
        {field: 'age', headerName: 'Age'},
        {field: 'tracking', headerName: 'Tracking'},
        {field: 'templateID', headerName: 'Template ID'},
        {field: 'statusCode', headerName: 'Status Code'},
        {field: 'nscAction', headerName: ''},
    ];
    inBoundColumnData: DsColumnData[] = [
        // {field: 'image', headerName: 'Image'},
        {field: 'VIN', headerName: 'Vin'},
        {field: 'model', headerName: 'Model Code'},
        {field: 'description', headerName: 'Description'},
        {field: 'receivingPlant', headerName: 'Receiving Plant'},
        {field: 'storageLocationAvail', headerName: 'Storage Location'},
        {field: 'rfsDate', headerName: 'RFS Date'},
        {field: 'age', headerName: 'Age'},
        {field: 'tracking', headerName: 'Tracking'},
        {field: 'templateID', headerName: 'Template ID'},
        {field: 'statusCode', headerName: 'Status Code'},
        {field: 'inBoundAction', headerName: ''},
    ];
    outboundColumnData: DsColumnData[] = [
        // {field: 'image', headerName: 'Image'},
        {field: 'VIN', headerName: 'Vin'},
        {field: 'model', headerName: 'Model Code'},
        {field: 'description', headerName: 'Description'},
        {field: 'receivingPlant', headerName: 'Receiving Plant'},
        {field: 'storageLocationAvail', headerName: 'Storage Location'},
        {field: 'rfsDate', headerName: 'RFS Date'},
        {field: 'age', headerName: 'Age'},
        {field: 'tracking', headerName: 'Tracking'},
        {field: 'templateID', headerName: 'Template ID'},
        {field: 'statusCode', headerName: 'Status Code'},
        {field: 'outboundAction', headerName: ''},
    ];
    loadingAreaConfig: DsLoadingAreaConfiguration = {id: 'bodyLoading'};
    showTable: boolean = false;
    modalIsOpen: boolean = false;

    constructor(
        private readonly stockService: StockService,
        private readonly goodsMovementService: GoodsMovementService,
        private readonly loadingAreaService: DsLoadingAreaService
    ) {
    }

    config: Partial<DsTableConfig> = {
        hasColumnDivider: true,
        hasStickyHeader: true,
        hasZebraRows: true,
        hasHeaderRowDivider: true,
        hasHeader: true,
        hasOuterDivider: true,
    };
    showroomDocRequest: ShowroomDocRequest = {
        iv_bodyno: '',
        iv_vin: '',
        iv_dealercode: localStorage.getItem('dealerCode') || '',
        iv_lunch: '',
    };

    onDownloadClick(vin: string | number): void {
        this.loadingAreaConfig = {
            id: 'bodyLoading',
            loadingTitle: 'Loading',
            loadingText: 'Downloading Document',
        };
        this.showroomDocRequest.iv_vin = vin.toString();
        this.showroomDocRequest.iv_bodyno = vin.toString().slice(-8);
        this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
        this.stockService.downloadShowroomDoc(this.showroomDocRequest).subscribe(
            (response: ShowroomDocResponse) => {
                if (response.es_message.ind === 'E') {
                    console.log(response.es_message.text);
                } else {
                    this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
                    const decodedDoc = atob(response.ev_pdf); // Decode the Base64 string
                    const byteArray = new Uint8Array(decodedDoc.length);
                    for (let i = 0; i < decodedDoc.length; i++) {
                        byteArray[i] = decodedDoc.charCodeAt(i);
                    }
                    console.log('Document downloaded successfully:', response);
                    const blob = new Blob([byteArray], {type: 'application/pdf'});
                    const url = window.URL.createObjectURL(blob);
                    window.open(url, '_blank');
                }
            },
            (error: unknown) => {
                this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
                this.modalData.title = 'Error';
                this.modalData.message = 'Failed to load PDF document.';
                this.modalIsOpen = true;
                console.error('Error downloading document:', error);
            }
        );
    }

    transferVehicle(goodsRequest: CreateGoodsMvtRequest): void {
        console.log(
            `Transferring vehicle with VIN and model: goodsRequest`,
            goodsRequest
        );

        this.loadingAreaConfig = {
            id: 'bodyLoading',
            loadingTitle: 'Loading',
            loadingText: 'Transferring Vehicle',
        };
        this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
        this.goodsMovementService.createGoodsMovement(goodsRequest).subscribe(
            (response) => {
                this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
                console.log('Vehicle transfer successful:', response);
                if (response.returnMessages[0].type === 'E') {
                    this.modalData.title = 'Error';
                    this.modalData.message = response.returnMessages[0].messageText;
                    this.modalIsOpen = true;
                } else {
                    this.modalData.title = 'Vehicle Transfer';
                    this.modalData.message = response.returnMessages[0].messageText;
                    this.modalIsOpen = true;
                }
            },
            (error) => {
                console.error('Error transferring vehicle:', error);
                this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
            }
        );
    }

    validateAllDSPcheck(): void {
        console.log('testing');
        if (this.requestPayload.dspStockFlag === 'X') {
            if (this.isModelSelected !== null && !this.isModelSelected) {
                console.log('Vehicle transfer successfully:', this.isModelSelected);
                this.modalData.title = 'Alert';
                this.modalData.message =
                    'Please select a model to search all DSP available stock.';
                this.modalIsOpen = true;
                this.rowsData = [];
                return;
            } else {
                this.onAvailableVehicleTabClick();
            }
        } else {
            this.onAvailableVehicleTabClick();
        }
    }

    onAvailableVehicleTabClick(): void {
        console.log('Available Vehicle Tab Clicked');
        this.activeTabId = 'available';
        this.isAvailableTabClicked = true;
        this.modalIsOpen = false;
        this.loadingAreaConfig = {
            id: 'bodyLoading',
            loadingTitle: 'Loading',
            loadingText: 'Available Vehicles',
        };
        this.rowsData = [];
        this.stockItems = [];
        this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);

        if (this.requestPayload) {
            this.stockService.getAvailableStock(this.requestPayload).subscribe(
                (response: StockResponse) => {
                    this.processAvailStockResponse(response);
                },
                (error) => {
                    this.handleError(error);
                }
            );
        }
    }

    onBlockedVehicleTabClick(): void {
        this.activeTabId = 'blocked';
        this.isAvailableTabClicked = false;
        this.loadingAreaConfig = {
            id: 'bodyLoading',
            loadingTitle: 'Loading',
            loadingText: 'Blocked Vehicles',
        };
        this.rowsData = [];
        this.stockItems = [];
        this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);

        if (this.requestPayload) {
            this.stockService.getBlockedStock(this.requestPayload).subscribe(
                (response: StockResponse) => {
                    this.processStockResponse(response);
                },
                (error) => {
                    this.handleError(error);
                }
            );
        }
    }

    onOTPTabClick(): void {
        this.activeTabId = 'otp';
        this.isAvailableTabClicked = false;
        this.loadingAreaConfig = {
            id: 'bodyLoading',
            loadingTitle: 'Loading',
            loadingText: 'OTP Vehicles',
        };
        this.rowsData = [];
        this.stockItems = [];
        this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);

        if (this.requestPayload) {
            this.stockService.getOTPStock(this.requestPayload).subscribe(
                (response: StockResponse) => {
                    console.log('OTP location response', response);
                    this.processStockResponse(response);
                },
                (error) => {
                    this.handleError(error);
                }
            );
        }
    }

    onQuotationTabClick(): void {
        this.activeTabId = 'quotation';
        this.isAvailableTabClicked = false;
        this.loadingAreaConfig = {
            id: 'bodyLoading',
            loadingTitle: 'Loading',
            loadingText: 'Quotation Vehicles',
        };
        this.rowsData = [];
        this.stockItems = [];
        this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);

        if (this.requestPayload) {
            this.stockService.getQuoteStock(this.requestPayload).subscribe(
                (response: StockResponse) => {
                    this.processStockResponse(response);
                },
                (error) => {
                    this.handleError(error);
                }
            );
        }
    }

    onNscTabClick(): void {
        if (this.isModelSelected !== null && this.isModelSelected === false) {
            this.modalData.title = 'Alert';
            this.modalData.message = 'Please select a model to view NSC stock.';
            this.modalIsOpen = true;
            this.rowsData = [];
            return;
        } else {
            this.activeTabId = 'nsc';
            this.isAvailableTabClicked = false;
            this.loadingAreaConfig = {
                id: 'bodyLoading',
                loadingTitle: 'Loading',
                loadingText: 'NSC Vehicles',
            };
            this.rowsData = [];
            this.stockItems = [];
            this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);

            if (this.requestPayload) {
                this.requestPayload.nscStockFlag = 'X';
                this.stockService.getAvailableStock(this.requestPayload).subscribe(
                    (response: StockResponse) => {
                        console.log('NSC location response', response);
                        this.processStockResponse(response);
                    },
                    (error) => {
                        this.handleError(error);
                    }
                );
            }
        }
    }

    onInboundTabClick(): void {
        this.activeTabId = 'inbound';
        this.isAvailableTabClicked = false;
        this.loadingAreaConfig = {
            id: 'bodyLoading',
            loadingTitle: 'Loading',
            loadingText: 'Inbound Vehicles',
        };
        this.rowsData = [];
        this.stockItems = [];
        this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);

        if (this.requestPayload) {
            this.stockService.getInboundStock(this.requestPayload).subscribe(
                (response: StockResponse) => {
                    this.processStockResponse(response);
                },
                (error) => {
                    this.handleError(error);
                }
            );
        }
    }

    onOutboundTabClick(): void {
        this.activeTabId = 'outbound';
        this.isAvailableTabClicked = false;
        this.loadingAreaConfig = {
            id: 'bodyLoading',
            loadingTitle: 'Loading',
            loadingText: 'Outbound Vehicles',
        };
        this.rowsData = [];
        this.stockItems = [];
        this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);

        if (this.requestPayload) {
            this.stockService.getOutboundStock(this.requestPayload).subscribe(
                (response: StockResponse) => {
                    this.processStockResponse(response);
                },
                (error) => {
                    this.handleError(error);
                }
            );
        }
    }

    onDemoTabClick(): void {
        this.activeTabId = 'demo';
        this.isAvailableTabClicked = false;
        this.loadingAreaConfig = {
            id: 'bodyLoading',
            loadingTitle: 'Loading',
            loadingText: 'Demo Vehicles',
        };
        this.rowsData = [];
        this.stockItems = [];
        this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);

        const demoRequest: DemoStockRequest = {
            dealerCode: this.requestPayload.dealerCode,
        };

        this.stockService.getDemoStock(demoRequest).subscribe(
            (response: DemoStockResponse) => {
                this.processDemoStockResponse(response);
            },
            (error) => {
                console.error('Error fetching demo stock:', error);
                this.handleError(error);
            }
        );
    }

    private getOtpAction(item: StockItem): string {
        if (this.requestPayload.plantCode === item.supplyingPlantCode) {
            return 'plantMatch';
        } else {
            return '';
        }
    }


    private processStockResponse(response: StockResponse): void {
        this.stockItems = response.stock;
        if (this.stockItems && this.stockItems.length > 0) {
            this.rowsData = this.stockItems.map(item => ({
                image: '',
                VIN: item.vin,
                model: item.modelCode,
                description: item.profileModelDescription,
                storageLocationAvail: item.storageLocationDescription,
                visibleOnDSP: item.visibleOnDSP ? 'true' : 'false',
                rfsDate: item.rfsDate,
                receivingPlant: item.plantName,
                rfiWeek: item.rfiWeek,
                otpStatus: item.otpStatus,
                age: item.entryDealerDays,
                productionWeek: item.productionWeek,
                tracking: item.lastTrackingpointDescription,
                templateID: item.templateId,
                dspReference: item.dspReference,
                deliveryStop: item.deliveryStop,
                daysToExpiry: item.daysToExpiry,
                customer: item.customerName,
                daysAtStatus: item.daysAtStatus,
                clusterID: item.clusterId,
                classification: item.classification,
                statusCode: item.statusCode,
                download: ' ',
                otpAction: this.getOtpAction(item),
                inBoundAction: !item.openSto ? 'Transfer' : '',
                reservedDownload: '',
                pofRobot: item.pofRobot,
                pofAttached: item.pofAttached,
            }));
            this.showTable = true;
            this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        } else {
            this.showTable = false;
            this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        }
    }

    private processAvailStockResponse(response: StockResponse): void {
        this.stockItems = response.stock;
        if (this.stockItems && this.stockItems.length > 0) {
            this.rowsData = this.stockItems.map(item => ({
                image: '', // empty initially
                VIN: item.vin,
                model: item.modelCode,
                description: item.profileModelDescription,
                storageLocationAvailable: item.storageLocationDescription,
                visibleOnDSP: item.visibleOnDSP ? 'true' : 'false',
                rfsDate: item.rfsDate,
                rfiWeek: item.rfiWeek,
                otpStatus: item.otpStatus,
                deliveryStop: item.deliveryStop,
                age: item.rfsDays,
                productionWeek: item.productionWeek,
                tracking: item.lastTrackingpointDescription,
                templateID: item.templateId,
                dspReference: item.dspReference,
                daysToExpiry: item.daysToExpiry,
                daysAtStatus: item.daysAtStatus,
                statusCode: item.statusCode,
                download: '',
                otpAction: this.getOtpAction(item),
            }));

            this.showTable = true;
            this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        } else {
            this.showTable = false;
            this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        }
    }

    private processDemoStockResponse(response: DemoStockResponse): void {
        const demoStockItems = response.demoStockItemList;
        this.rowsData = [];
        this.stockItems = [];
        if (demoStockItems && demoStockItems.length > 0) {
            this.rowsData = demoStockItems.map((item) => ({
                image: '',
                bodyNo: item.bodyNo,
                VIN: item.vin,
                dateCreated: item.dateCreated,
                timeCreated: item.timeCreated,
                retailPrice: item.retailPrice,
                lastAction: item.lastAction,
                purpose: item.purpose,
                model: item.model,
                mileage: item.mileage,
                modelDescription: item.modelDescription,
                docIndicator: item.docIndicator,
                podDate: item.podDate,
                daysToDefleet: item.daysToDefleet,
                bmwOrderNumber: item.bmwOrderNumber,
                tuvSudRefNumber: item.tuvSudRefNumber,
                appraisalStatus: item.appraisalStatus,
                noCo2: item.noCo2,
                demoStockAction: '',
            }));

            this.showTable = true;
            this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        } else {
            this.showTable = false;
            this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        }
    }

    private handleError(error: unknown): void {
        console.error('Error fetching stock data:', error);
        this.showTable = false;
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
    }

    onRFSTabClick() {
        this.activeTabId = 'rfs';
        this.loadingAreaConfig = {
            id: 'bodyLoading',
            loadingTitle: 'Loading',
            loadingText: 'Reserved For Sale Vehicles',
        };
        this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);

        if (this.requestPayload) {
            this.stockService.getRfsStock(this.requestPayload).subscribe(
                (response: StockResponse) => {
                    this.processStockResponse(response);
                },
                (error) => {
                    this.handleError(error);
                }
            );
        }
    }

    activeTabId: string = 'available';
    isAvailableTabClicked: boolean = false;

    triggerActiveTabAction() {
        switch (this.activeTabId) {
            case 'available':
                this.validateAllDSPcheck();
                break;
            case 'blocked':
                this.onBlockedVehicleTabClick();
                break;
            case 'otp':
                this.onOTPTabClick();
                break;
            case 'quotation':
                this.onQuotationTabClick();
                break;
            case 'nsc':
                this.onNscTabClick();
                break;
            case 'inbound':
                this.onInboundTabClick();
                break;
            case 'outbound':
                this.onOutboundTabClick();
                break;
            case 'demo':
                this.onDemoTabClick();
                break;
            case 'rfs':
                this.onRFSTabClick();
                break;
            default:
                break;
        }
    }

  onUploadSuccess() {
    this.onDemoTabClick();
  }
}
